import { Components, Theme } from '@mui/material/styles';

const LinkOverrides: Components<Theme> = {};

export default LinkOverrides;
